<ng-template #templateBillingRepairerDetail>
    <div class="modal-billing-repairer-detail">
        <div class="modal-header">
            <div class="d-flex flex-column">
                <h4 class="modal-title">{{ 'support.faturamento-oficinas.detail-cashback.header.title' | translate }}</h4>
                <span class="modal-subtitle">
                    <span>{{ 'support.faturamento-oficinas.detail-cashback.header.subtitle' | translate: { name: holdingName } }}</span>
                </span>
            </div>
            <div class="search-section">
                <form class="input-group">
                    <span class="input-group-text"><i class="fa fa-search"></i></span>
                    <input type="text" maxlength="100" [placeholder]="'support.faturamento-oficinas.detail-cashback.header.filter' | translate" class="form-control" name="search" [(ngModel)]="filter" />
                </form>
            </div>
            <button type="button" data-dismiss="modal" aria-label="Close" class="btn-close" (click)="close();"></button>
        </div>
        <div class="modal-body">
            <div class="content">
                @if (holdingCashbackInfoList.length > 0) {
                    <div class="header">
                        <div class="col-cashback-info col-order-id justify-content-center">
                            {{ 'support.faturamento-oficinas.detail-cashback.table.title.id' | translate }}
                        </div>
                        <div class="col-cashback-info col-supplier-name">
                            {{ 'support.faturamento-oficinas.detail-cashback.table.title.supplier' | translate }}
                        </div>
                        <div class="col-cashback-info col-release-date justify-content-end">
                            {{ 'support.faturamento-oficinas.detail-cashback.table.title.release-date' | translate }}
                        </div>
                        <div class="col-cashback-info col-cashback-type justify-content-end">
                            {{ 'support.faturamento-oficinas.detail-cashback.table.title.cashback-type' | translate }}
                        </div>
                        <div class="col-cashback-info col-cashback-value justify-content-end">
                            {{ 'support.faturamento-oficinas.detail-cashback.table.title.cashback-value' | translate }}
                        </div>
                        <div class="col-cashback-info col-order-value justify-content-end">
                            {{ 'support.faturamento-oficinas.detail-cashback.table.title.order-value' | translate }}
                        </div>
                        <div class="col-cashback-info col-order-date justify-content-end">
                            {{ 'support.faturamento-oficinas.detail-cashback.table.title.order-date' | translate }}
                        </div>
                    </div>
                    <ng-scrollbar>
                        @for (holdingCashbackInfo of filteredHoldingCashbackInfoList; track holdingCashbackInfo.orderId;) {
                            <div class="part">
                                <div class="col-cashback-info col-order-id justify-content-center">
                                    {{holdingCashbackInfo.orderId}}
                                </div>
                                <div class="col-cashback-info col-supplier-name">
                                    <span class="truncate">{{holdingCashbackInfo.supplierName}}</span>
                                </div>
                                <div class="col-cashback-info col-release-date justify-content-end">
                                    {{holdingCashbackInfo.cashbackReleaseDate | date: 'dd/MM/yyyy' }}
                                </div>
                                <div class="col-cashback-info col-cashback-type justify-content-end">
                                    {{holdingCashbackInfo.cashbackTypeDescription}}
                                </div>
                                <div class="col-cashback-info col-cashback-value justify-content-end">
                                    {{holdingCashbackInfo.cashbackValue | currency:'R$' }}
                                </div>
                                <div class="col-cashback-info col-order-value justify-content-end">
                                    {{holdingCashbackInfo.orderValue | currency:'R$' }}
                                </div>
                                <div class="col-cashback-info col-order-date justify-content-end">
                                    {{holdingCashbackInfo.orderDate | date: 'dd/MM/yyyy' }}
                                </div>
                            </div>
                        }
                    </ng-scrollbar>
                    <div class="footer">
                        <div class="col-cashback-info col-total">
                            {{ 'support.faturamento-oficinas.detail-cashback.table.footer.totals' | translate }}
                        </div>
                        <div class="col-cashback-info col-cashback-value justify-content-end">
                            {{ cashbackValueTotal | currency: 'R$' }}
                        </div>
                        <div class="col-cashback-info col-order-value  justify-content-end">
                            {{ orderValueTotal | currency: 'R$' }}
                        </div>
                        <div class="col-cashback-info col-order-date justify-content-end"></div>
                    </div>
                }
            </div>
        </div>
    </div>
    <ngx-ui-loader [loaderId]="'loader-repairer-cashback-info'"></ngx-ui-loader>
</ng-template>
